var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72927 7.3151H8.1901L11.1009 10.2318L10.2318 11.1009L7.3151 8.1901V7.72927L7.1576 7.56594C6.4926 8.1376 5.62927 8.48177 4.6901 8.48177C2.59594 8.48177 0.898438 6.78427 0.898438 4.6901C0.898438 2.59594 2.59594 0.898438 4.6901 0.898438C6.78427 0.898438 8.48177 2.59594 8.48177 4.6901C8.48177 5.62927 8.1376 6.4926 7.56594 7.1576L7.72927 7.3151ZM2.0651 4.6901C2.0651 6.1426 3.2376 7.3151 4.6901 7.3151C6.1426 7.3151 7.3151 6.1426 7.3151 4.6901C7.3151 3.2376 6.1426 2.0651 4.6901 2.0651C3.2376 2.0651 2.0651 3.2376 2.0651 4.6901Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24Px);
export default __webpack_public_path__ + "static/media/search_24px.f9bb3882.svg";
export { ForwardRef as ReactComponent };